import { graphql } from "api/cms-website/generated";

export const TreatmentInfoFragment = graphql(/* GraphQL */ `
    fragment TreatmentInfoFragment on ComponentComponentsTreatmentInfo {
        id
        treatmentInfoTitle: title
        treatmentInfoSubtitle: subtitle
        treatmentInfoItems: items {
            ...TreatmentInfoItemFragment
        }
    }
`);
